<script setup lang="ts">
	const props = withDefaults(
		defineProps<{
			categories: string[];
			data: number[];
			color?: string
		}>(),
		{
			categories: () => [] as string[],
			data: () => [] as number[],
			color: () => "F79327"
		}
	);

	const label = ref(props.categories);

	const chartOptions = {
		chart: {
			type: "radialBar",
			height: '100%',
			animations: {
				enabled: true,
				speed: 800,
				animateGradually: {
					enabled: true,
					delay: 100
				},
				dynamicAnimation: {
					enabled: true,
					speed: 500
				}
			},
		},
		grid: {
			padding: {
				bottom: -15,
				left: 20,
			}
		},
		legend: {
			show: false,
		},
		labels: label.value,
		plotOptions: {
			radialBar: {
				startAngle: 0,
				endAngle: 360,
				hollow: {
					margin: 0,
					size: "50%",
					background: '#fff',
					image: undefined,
					imageOffsetX: 0,
					imageOffsetY: 0,
					position: 'front',
					dropShadow: {
						enabled: true,
						top: 3,
						left: 0,
						blur: 4,
						opacity: 0.3
					}
				},
				track: {
					show: true,
					startAngle: undefined,
					endAngle: undefined,
					background: '#FFF',
					strokeWidth: '67%',
					opacity: 1,
					margin: 5, 
					dropShadow: {
						enabled: true,
						top: -2,
						left: 0,
						blur: 3,
						opacity: 0.1
					}
				},
				dataLabels: {
					showOn: 'always',
					name: {
						offsetY: -3,
						show: true,
						fontSize: "13px",
						color: '#19213D',
						fontWeight: 600
					},
					value: {
						// formatter: function(val: any) {
						// 	return parseInt(val)+"%";
						// },
						offsetY: 0,
						fontSize: "13px",
						color: "#19213D",
						fontWeight: 600
					},
				},
			},
		},
		fill: {
			type: "gradient",
			colors: [props.color],
			gradient: {
				shade: "dark",
				shadeIntensity: 0.01,
				inverseColors: false,
				opacityFrom: 1,
				opacityTo: 1,
				stops: [0, 50, 65, 91],
			},
		},
		stroke: {
			lineCap: "round",
		},
		tooltip: {
			enabled: true,
		},
	};
</script>

<template>
	<ClientOnly>
		<apexchart 
			type="radialBar" 
			:options="chartOptions" 
			:series="props.data" 
			:height="200" 
		/>
	</ClientOnly>
</template>

<style lang="scss" scoped></style>
